import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 26 23',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M21.669,8.625H16.51L11.766.362A.723.723,0,0,0,11.139,0H7.15a.719.719,0,0,0-.694.916L8.669,8.625H5.78L3.83,6.037a.724.724,0,0,0-.578-.288H.725a.719.719,0,0,0-.7.893L1.447,11.5.025,16.357a.719.719,0,0,0,.7.893H3.253a.723.723,0,0,0,.578-.288l1.95-2.588H8.669L6.456,22.084A.72.72,0,0,0,7.15,23h3.988a.723.723,0,0,0,.627-.362l4.745-8.263h5.159c1.6,0,4.333-1.287,4.333-2.875S23.265,8.625,21.669,8.625Zm0,4.313h-6L10.72,21.562H8.108l2.476-8.625H5.058L2.891,15.812h-1.2L2.951,11.5,1.688,7.187h1.2l2.167,2.875h5.526L8.108,1.437H10.72l4.952,8.625h6c1.184,0,2.826.977,2.889,1.433C24.5,11.96,22.854,12.937,21.669,12.937Z"
          transform="translate(-0.003)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
